import styled from '@emotion/styled';

export const PrimaryButton = styled.button`
  border-radius: 0.5rem;
  color: white;
  background: ${({ theme }) => theme.palette.primaryButtonColor};
  border: 1px solid transparent;
  border-radius: 0.5rem;
  padding: 0.88rem 2rem;
  cursor: pointer;
  font-weight: 600;
  font-size: 1rem;
`;

export const PrimaryBlackButton = styled.button`
  padding: 13px 32px;
  font-size: 16px;
  font-weight: 600;
  background-color: black;
  height: 48px;
  border-radius: 8px;
  color: white;
  border: 1px solid black;
  display: flex;
  cursor: pointer;

  justify-content: center;
  align-items: center;

  &:hover {
    border-color: white !important;
  }
`;

export const GreyBorderBlackTextButton = styled.button`
  padding: 14px 32px;
  font-size: 16px;
  font-weight: 600;

  height: 50px;
  color: black;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  background-color: white;
  border-radius: 8px;
  cursor: pointer;

  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: center;

  &:hover {
    background-color: #9b9a9a1b !important;
    color: black !important;
  }
`;

export const TertiaryButton = styled.button`
  padding: 13px 0;
  font-size: 16px;
  font-weight: 600;

  height: 48px;
  background-color: white;
  gap: 12px;
  display: flex;
  align-items: center;
  border: none;
  cursor: pointer;

  &:hover {
    background-color: inherit !important;
    color: #000000a7 !important;
  }
`;

export const RedBorderButton = styled.button`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  padding: 13px 24px;
  line-height: 22px;
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: center;

  color: ${({ theme }) => theme.palette.redFontColor};
  height: fit-content;
  cursor: pointer;
  background-color: white;

  &:hover {
    background-color: #ffd2d81c !important;
  }
`;

export const RedBgButton = styled.button`
  border: 1px solid ${({ theme }) => theme.palette.redFontColor};
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  padding: 13px 24px;
  line-height: 22px;
  display: flex;
  align-items: center;
  gap: 12px;

  color: white;
  background-color: ${({ theme }) => theme.palette.redFontColor};
  height: fit-content;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) =>
      theme.palette.redHoverFontColor} !important;
  }
`;
